import { Component } from '@angular/core';
import { CoreSignalPatentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Patents') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalpatent-form',
    templateUrl: './coresignalpatent.form.component.html'
})
export class CoreSignalPatentFormComponent extends BaseFormComponent {
    public record!: CoreSignalPatentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

